// extracted by mini-css-extract-plugin
module.exports = {"details":"detail_details__cidj6"};